<template>
    <div :class="{ 'user-button-container': !nameIsDisable }">
      <img
        v-if="showAvatar"
        :src="avatar"
        class="avatar ma-0"
        :style="{ width: avatarWidth, height: avatarHeight }"
      />
      <div class="text-container" :class="{ 'with-avatar': showAvatar}" v-if="nameIsDisable" @click="$emit('click')">
        <div
          class="name-container"
          :class="{ 'user-info-text': locationInApp === 'hub' }"
          :style="{ 'font-size': nameSize }"
        >
          <span v-if="!showAvatar" class="helloSpan">{{ $t("Hello") }}, </span>
          <span class="fullName">{{ name }}</span>
          <span class="shortName">{{ firstName }}</span>
        </div>
      </div>
    </div>
  </template>

  <script>
  export default {
    props: {
      locationInApp: {},
      avatarWidth: String,
      avatarHeight: String,
      nameSize: String,
      nameIsDisable: { type: Boolean, default: true },
      showAvatar: {
        type: Boolean,
        default: true,
      },
    },

    computed: {
      avatar() {
        return this.$store.getters.currentUserImage;
      },
      name() {
        return this.$store.getters.currentUserName;
      },
      firstName() {
        return this.$store.getters.currentUserFirstName;
      },
    }
  };
  </script>

  <style scoped>
  .user-button-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    height: 100%;
    color: #231E46;
  }

  @media only screen and (max-width: 1150px) {
    .user-button-container {
      font-size: 12px;
    }
  }

  @media only screen and (max-width: 750px) {
    .shortName {
      display: contents !important;
    }
    .fullName,
    .helloSpan {
      display: none;
    }
  }

  @media only screen and (max-height: 700px) {
    .user-button-container {
      font-size: 12px;
    }
  }

  .avatar {
    border-radius: 0.5rem;
    margin-right: 3%;
    object-fit: cover;
  }
  .text-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-evenly;
    text-align: left;
    color: #231E46;
    cursor: pointer;
  }
  .name-container {
    margin-right: 10px;
    max-width: 300px;
    max-height: 50px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color:black;
  }
  .user-info-text {
    font-weight: bold;
    text-transform: uppercase;
    color: #231E46;
    font-size: 16px;
  }

  .shortName {
    display: none;
  }
  </style>



// WEBPACK FOOTER //
// src/newComponents/_Molecules/UserButton.vue